import apiHelper from '../helper/ApiHelper';
import { showErrorToast } from "../utils/AlertUtils";

const LedgerService = {
  async getLedgers() {
    try {
      return await apiHelper('/ledger');
    } catch (error) {
      console.error('Error fetching ledgers:', error);
      showErrorToast(error.message);
      throw error;
    }
  },

  async ledgerCalculations() {
    try {
      return await apiHelper('/ledger/calculations');
    } catch (error) {
      console.error('Error fetching calculations:', error);
      showErrorToast(error.message);
      throw error;
    }
  },

  async getLedgerById(id) {
    try {
      return await apiHelper(`/ledger/${id}`);
    } catch (error) {
      console.error('Error fetching ledger details:', error);
      showErrorToast(error.message);
      throw error;
    }
  },

  async createLedger(ledger) {
    try {
      return await apiHelper('/ledger', 'POST', ledger);
    } catch (error) {
      console.error('Error creating ledger:', error);
      showErrorToast(error.message);
      throw error;
    }
  },

  async updateLedger(ledgerId, ledger) {
    try {
      return await apiHelper(`/ledger/${ledgerId}`, 'PUT', ledger);
    } catch (error) {
      console.error('Error updating ledger:', error);
      showErrorToast(error.message);
      throw error;
    }
  },

  async deleteLedger(id) {
    try {
      return await apiHelper(`/ledger/${id}`, 'DELETE');
    } catch (error) {
      console.error('Error deleting ledger:', error);
      showErrorToast(error.message);
      throw error;
    }
  },
};

export default LedgerService;